import React, { lazy, Suspense, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import { LANG_ID } from "constants/AuthConstant";
import { DIR_LTR, DIR_RTL } from "constants/ThemeConstant";
import { onDirectionChange, onLocaleChange } from "store/slices/themeSlice";
import i18next from "i18next";
import { useEffect } from "react";
const SinglePageLayout = lazy(() => import("./SinglePageLayout"));
const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token
    ? !blankLayout
      ? AppLayout
      : SinglePageLayout
    : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };
  const dispatch = useDispatch();
  const getLanguage = () => {
    const langId = localStorage.getItem(LANG_ID);
    var dir = langId === "ar" ? DIR_RTL : DIR_LTR;

    dispatch(onDirectionChange(dir));

    dispatch(onLocaleChange(langId));
    i18next.changeLanguage(langId);
  };
  useEffect(() => {
    //  getLanguage();
  }, []);
  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      // locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <Layout direction={direction}>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
